// Lightweight Google Analytics (GA4) helper.
// gtag is loaded in public/index.html and only initialised on the production
// domain, so these calls are safe no-ops in preview/dev.
export const GA_MEASUREMENT_ID = 'G-V2K4QLC81R';

const hasGtag = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

export const trackEvent = (name, params = {}) => {
  if (hasGtag()) window.gtag('event', name, params);
};

export const trackPageView = (path) => {
  if (hasGtag()) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
};
